<div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h3 class="m-0 font-weight-bold" style="color: #1A355E;"></h3>
        <ol class="breadcrumb ">
            <li class="breadcrumb-item active">Hareketler</li>
            <li class="breadcrumb-item active"><a routerLink="/customer-terminal">Müşteri Terminal Ataması</a></li>
            <li class="breadcrumb-item active">Müşteri Terminal Ataması Güncelle</li>
        </ol>
    </div>
    <div class="container">
        <div class="card mb-4">
            <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h3 class="m-0 font-weight-bold" style="color: #1A355E;">Müşteri Terminal Ataması Güncelle</h3>
            </div>
            <br>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="update()">
                    <div>
                        <fieldset>
                            <div class="col-md-12">                            
                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Müşteri</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="customers$ | async" [style]="{'width': '100%'}" [virtualScroll]="true" [itemSize]="31"
                                                optionLabel="definitioN_" optionValue="logicalref" [filter]="true" [filterBy]="'code,definitioN_'"
                                                placeholder="Müşteri Seçimi Yapınız." [readonly]="true"
                                                formControlName="customerId">
                                                <ng-template let-customers pTemplate="item">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-4">
                                                            <span class="badge badge-success">Kod-->
                                                                {{customers.code}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-8">
                                                            <span class="badge badge-danger">Müşteri -->
                                                                {{customers.definitioN_}}</span>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('customerId').hasError('required')&& form.get('customerId').touched">Müşteri
                                            boş geçilemez!</small>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="txtInput01"><span class="badge badge-danger"
                                            style="font-size:1rem;">**Abonelik</span></label>
                                    <div class="input-valid">
                                        <div class="w-100">
                                            <p-dropdown [options]="contracts$ | async" [style]="{'width': '100%'}"
                                                optionLabel="serviceName" optionValue="id" [filter]="true" [filterBy]="'serviceName,contractTypeName,projectName,serviceUnitPrice'"
                                                placeholder="Abonelik Seçimi Yapınız." [readonly]="true"
                                                formControlName="contractId">
                                                <ng-template let-contracts pTemplate="item">
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-2">
                                                            <span class="badge badge-danger">No -->
                                                                {{contracts.contractNumber}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-4">
                                                            <span class="badge badge-success">Hizmet-->
                                                                {{contracts.serviceName}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-4">
                                                            <span class="badge badge-warning">Proje-->
                                                                {{contracts.projectName}}</span>
                                                        </div>
                                                        <div class="col-sm-12 col-md-2">
                                                            <span class="badge badge-info">Hizmet Bedeli-->
                                                                {{contracts.serviceUnitPrice}}</span>
                                                        </div>

                                                    </div>
                                                </ng-template>
                                            </p-dropdown>
                                        </div>
                                        <small class="form-text text-danger"
                                            *ngIf="form.get('contractId').hasError('required')&& form.get('contractId').touched">Müşteri
                                            boş geçilemez!</small>
                                    </div>
                                </div>
                                <p-pickList [source]="terminals$ | async" [target]="targetTerminals"
                                    sourceHeader="Havuzdaki Terminaller" targetHeader="Seçilen Terminaller"
                                    [dragdrop]="true" [responsive]="true" [sourceStyle]="{'height':'225px'}"
                                    [targetStyle]="{'height':'225px'}" filterBy="terminalId"
                                    sourceFilterPlaceholder="Ara" targetFilterPlaceholder="Ara"
                                    [showSourceControls]="false" [showTargetControls]="false">
                                    <ng-template let-terminals pTemplate="item">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6">
                                                <span class="badge badge-success">ID--> {{terminals.terminalId}}</span>
                                            </div>
                                            <div class="col-sm-12 col-md-6">
                                                <span class="badge badge-danger">IMEI--> {{terminals.imei}}</span>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-pickList>


                            </div>
                            <div class="col-md-12 text-right">
                                <div class="btn-group" role="group" aria-label="Basic example">
                                    <button pButton type="button" class="p-button-rounded p-button-danger"
                                        label="Vazgeç" routerLink="/customer-terminal"></button>
                                    <button pButton type="submit" class="p-button-rounded p-button-success"
                                        label="Kaydet" [disabled]="!form.valid"></button>
                                </div>
                            </div>

                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>